import { WithLegacy } from '~/_legacy/components/WithLegacy';

import { OnlyWeb } from '~/components/_for-next/OnlyWeb';
import { WithNextSeo } from '~/components/_for-next/WithNextSeo';

import { Template } from './_template';

export default function Page() {
  return (
    <WithNextSeo
      title={'社会的事業を行う非営利・営利法人の実態調査レポート2023'}
      description={
        '前調査から5年が経った今、改めて地域社会の現場で社会課題解決の中心的役割を担われている組織の体制、財務、広報、人材、連携に関するご活動の現状と課題を調査分析しました。'
      }
      image={'/survey/top.png'}
      url={'/survey'}
    >
      <OnlyWeb>
        <WithLegacy>
          <Template />
        </WithLegacy>
      </OnlyWeb>
    </WithNextSeo>
  );
}
